/**
 * @typedef {{
 *     "company": string,
 *     "industry": string,
 *     "priorities": string,
 *     "multiChannel": string,
 *     "How many unique site visitors do you have annually?": string,
 *     "How many subscribers does your company have across all marketing channels?": string,
 *     "What is the annual send volume across all channels?": string,
 *     "What percent of your send volume is batch & blast campaigns?": string,
 *     "What is the annual marketing attributed revenue across channels considered?": string,
 *     "What is the average transaction value?": string,
 *     "What is the current annual churn rate of your customers?": string,
 *     "How many marketers are required to support your current campaign operations?": string,
 *     "How many engineering resources are required to support marketing?": string,
 * }} RoiCalculatorFormData
 */


/**
 * @param roiCalculatorDocument {Document}
 * @param onFormUpdated {(data: RoiCalculatorFormData) => void}
 * @return {void}
 */
module.exports = function listenToRoiCalculatorFormUpdatedEvent(roiCalculatorDocument, onFormUpdated) {
    roiCalculatorDocument.addEventListener("formUpdated", (e) => {
        if ('calculatorData' in e.detail) {
            /**
             * @type {RoiCalculatorFormData}
             */
            const data = e.detail.calculatorData;

            onFormUpdated(data);
        }
    });
}
